import * as React from "react";
import Compose from "./Compose";
import { MessageActions } from "src/Core/Common/Enums";
import DocumentForm from "./DocumentForm";

interface IComposeWizardProps {
    showCompose: boolean;
    handleOnContinueClick: () => void;
    handleOnBackClick: () => void;
    isMounted:boolean
}

const ComposeWizard: React.FC<IComposeWizardProps> = props => {
    return (
        <>
            {props.showCompose && (
                <Compose
                    messageAction={MessageActions.New}
                    showCompose={props.showCompose}
                    handleOnContinueClick={props.handleOnContinueClick}
                    handleOnBackClick={props.handleOnBackClick}
                    isMounted={props.isMounted}
                />
            )}
            {!props.showCompose && <DocumentForm onContinueclick={props.handleOnContinueClick} />}
        </>
    );
};

export default ComposeWizard;
